import { render, staticRenderFns } from "./setTemplate.vue?vue&type=template&id=32c2d7e9&scoped=true"
import script from "./setTemplate.vue?vue&type=script&lang=js"
export * from "./setTemplate.vue?vue&type=script&lang=js"
import style0 from "./setTemplate.vue?vue&type=style&index=0&id=32c2d7e9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c2d7e9",
  null
  
)

export default component.exports